<script setup lang="ts"></script>

<template>
  <header class="header">
    <div class="header__container">
      <div class="header__logo">
        <router-link class="header__link" :to="{ name: 'home' }" aria-label="To the homepage">
          <div class="header__logo-container">
            <img alt="Norhybrid logo" class="header__logo-image" src="@/assets/logo.png" />
          </div>
        </router-link>
      </div>
    </div>
  </header>
</template>

<style>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.header__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
}

.header__logo {
  display: flex;
}

.header__link {
  display: flex;
}

.header__logo-container {
  display: flex;
}

.header__logo-image {
  max-width: 65%;
  height: auto;
}
</style>
